import { useState, useEffect, useCallback } from 'react';

/**
 * Hook para cargar y gestionar los comandos y atajos rápidos del asesor en el chat.
 */
export const useTicketAtajos = ({
  token,
  idUsuario,
  messageInputRef,
  setInputText,
  onSendMessage
}) => {
  const [quickCommands, setQuickCommands] = useState([]);

  const fetchAtajos = useCallback(async () => {
    if (!token) return;
    try {
      const query = idUsuario ? `?idUsuario=${idUsuario}` : '';
      const response = await fetch(`/api/SupportEngine/GetAtajos${query}`, {
        headers: { Accept: 'application/json', Authorization: 'Bearer ' + token }
      });
      if (response.ok) {
        const result = await response.json();
        const list = result.data || result;
        if (Array.isArray(list)) {
          setQuickCommands(list);
        }
      }
    } catch (err) {
      console.error('Error al cargar atajos de soporte:', err);
    }
  }, [token, idUsuario]);

  useEffect(() => {
    fetchAtajos();
  }, [fetchAtajos]);

  const handleQuickCommand = useCallback((cmdText, sendImmediately = false) => {
    if (sendImmediately) {
      if (onSendMessage) {
        onSendMessage(null, cmdText);
      }
    } else {
      if (setInputText) {
        setInputText(cmdText);
      }
      // Enfocar el input de mensaje y situar cursor al final
      setTimeout(() => {
        if (messageInputRef?.current) {
          messageInputRef.current.focus();
          const len = (cmdText || '').length;
          messageInputRef.current.setSelectionRange?.(len, len);
        }
      }, 30);
    }
  }, [onSendMessage, setInputText, messageInputRef]);

  return {
    quickCommands,
    fetchAtajos,
    handleQuickCommand
  };
};
